import { useContext } from "react";

import { type CheckoutV2Configuration } from "@jti/commerce";

import { CheckoutV2ConfigurationContext } from "../../CheckoutV2ConfigurationProvider";

export const useCheckoutV2Configuration = (): CheckoutV2Configuration => {
  const context = useContext(CheckoutV2ConfigurationContext);

  if (!context) {
    throw new Error("useCheckoutV2Configuration used outside of CheckoutV2ConfigurationProvider");
  }

  return context;
};
